import {
  Box,
  Typography
} from '@mui/material';
import React, { useState } from 'react';

import FinalLisVotersReport from './FinalLisVotersReport';
import { FinalListFilters } from '../../../types';
import FinalListForm from './FinalListForm';

const FinalListReport: React.FC = () => {
  const [filters, setFilters] = useState<FinalListFilters>();

  const onGenerateReport = (filters: FinalListFilters) => {
    console.log('Generating final list report with filters:', filters);
    setFilters(filters);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Final List Report
      </Typography>
      <FinalListForm onGenerateReport={onGenerateReport} />
      { filters && <FinalLisVotersReport filters={filters} /> }
    </Box>
  );
};

export default FinalListReport;
